import { FinancialType, IncomeStatementType } from "./Enums";

export class IncomeStatement {
    ID: string;
    YEAR: number;
    FINANCIAL_TYPE: FinancialType;
    IS_TYPE: IncomeStatementType;
    MONTHS: number;
    REVENUE: number;
    PROFIT: number;
    INTEREST: number;
    DEPRECIATION: number;
    AMORTIZATION: number;
    OFFICER_COMP: number;
    GUARANTEED_PAYMENTS: number;
    WEIGHT: number;
    OUTLIER: boolean;
    GM_SALARY: number;
    GM_SALARY_TAX: boolean;
    FYE_DATE: string;
    OFFICER_COMP_TAX: boolean;

    TOTAL_ADJUSTMENTS: number;
    SDE: number;
    EBITDA: number;


    static parse(json: any): IncomeStatement {
        if (json) {
            const is = new IncomeStatement();

            is.ID = json.ID;
            is.YEAR = json.YEAR;
            is.FINANCIAL_TYPE = FinancialType[<string>json.FINANCIAL_TYPE];
            is.IS_TYPE = IncomeStatementType[<string>json.IS_TYPE];
            is.MONTHS = json.MONTHS;
            is.REVENUE = json.REVENUE;
            is.PROFIT = json.PROFIT;
            is.INTEREST = json.INTEREST;
            is.DEPRECIATION = json.DEPRECIATION;
            is.AMORTIZATION = json.AMORTIZATION;
            is.OFFICER_COMP = json.OFFICER_COMP;
            is.GUARANTEED_PAYMENTS = json.GUARANTEED_PAYMENTS;
            is.OUTLIER = json.OUTLIER;
            is.WEIGHT = json.WEIGHT;
            is.GM_SALARY = json.GM_SALARY;
            is.GM_SALARY_TAX = json.GM_SALARY_TAX;
            is.FYE_DATE = json.FYE_DATE;
            is.OFFICER_COMP_TAX = json.OFFICER_COMP_TAX;

            is.TOTAL_ADJUSTMENTS = json.TOTAL_ADJUSTMENTS;
            is.SDE = json.SDE;
            is.EBITDA = json.EBITDA;

            return is;
        } else return null;
    }

    static parseArray(json: Array<any>): Array<IncomeStatement> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(IncomeStatement.parse(j));

        return arr;
    }

    public static isAvailable(is: IncomeStatement): boolean {
      return !(is.FINANCIAL_TYPE === null || is.FINANCIAL_TYPE === undefined ||
        is.FINANCIAL_TYPE === FinancialType.NOT_AVAILABLE || is.FINANCIAL_TYPE === FinancialType.NOT_ENTERED);
    }

    public static getFieldFullName(fieldName: string): string {
      let fullName: string = '';
      switch (fieldName) {
        case 'REVENUE':
          fullName = 'Revenue';
          break;
        case 'PROFIT':
          fullName = 'Profit before taxes';
          break;
        case 'INTEREST':
          fullName = 'Interest';
          break;
        case 'DEPRECIATION':
          fullName = 'Depreciation';
          break;
        case 'AMORTIZATION':
          fullName = 'Amortization';
          break;
        case 'OFFICER_COMP':
          fullName = 'All Owner’s Compensation';
          break;
        case 'GUARANTEED_PAYMENTS':
          fullName = 'Guaranteed Payment to Partners';
          break;
      }
      return fullName;
    }
}


export class IncomeStatementRequest {
    FYE_DATE: string;
    RECENT_FINANCIAL_DATE: string;


    static parse(json: any): IncomeStatementRequest {
        if (json) {
            const isr = new IncomeStatementRequest();

            isr.FYE_DATE = json.FYE_DATE;
            isr.RECENT_FINANCIAL_DATE = json.RECENT_FINANCIAL_DATE;


            return isr;
        } else return null;
    }
}
